import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EventService } from "../services/EventService/EventService";
import EventSummary from "../types/EventSummary";
import PageHelper from "./PageHelper";

const Events: React.FC = () => {
    const { year: yearParam } = useParams<{ year?: string }>(); // Get the year parameter from the URL
    const [years, setYears] = useState<number[]>([]);
    const [eventsPerYear, setEventsPerYear] = useState<EventSummary[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
      const loadYears = async () => {
        try {
          const allYears = await EventService.fetchAllEventYears(true);
          setYears(allYears);
        } catch (err) {
          setError(err instanceof Error ? err.message : "Unknown error");
        }
      };

      const loadEventsForYear = async () => {
        try {
            var selectedYear = yearParam ? parseInt(yearParam, 10) : new Date().getFullYear(); // Default to current year if no year is provided
            var events = await EventService.fetchEvents(selectedYear, true); // Fetch events for selected year in descending order
            if (events.length === 0) {
              selectedYear = selectedYear - 1;
              events = await EventService.fetchEvents(selectedYear, true);
            }
            setEventsPerYear(events);
        } catch (err) {
          setError(err instanceof Error ? err.message : "Unknown error");
        }
      };

      loadYears();
      loadEventsForYear();
    }, [yearParam]);

    
    if (error) {
      return <div>Error: {error}</div>;
    }
    if (years.length === 0) {
      return <div>Loading years...</div>;
    }
  
    return (
    <div id="content">
        <h1>{yearParam} Off-Road Events</h1>
        <div style={{float:"left", width:"620px"}}>
            <p>Please take a look at the galleries from the events that our team of 
                photographers covered during the {yearParam} season</p>
            <table width="610px" style={{border:'0px'}} cellSpacing={1} cellPadding={0}>
                <tbody>
                <tr>
                    <td valign="top">&nbsp;</td>
                    <td valign="top"><strong>Event</strong></td>
                    <td valign="top"><strong>Date</strong></td>
                    <td valign="top"><strong>Location</strong></td>
                    <td valign="top"><strong>Photos</strong></td>
                </tr>
                
                {eventsPerYear.map((event) => (
                <tr key={event.id}>
                    <td valign="top">
                        <a href={`/event/${event.id}`}>
                        <img alt={event?.id} width="160" height="107"
                             src={event?.id && event?.eventThumb 
                                ? PageHelper.getImageSourceUrl(event.id, "thumb", event.eventThumb) 
                                : ""} />
                        </a>
                    </td>
                    <td valign="top">
                        <a href={`/event/${event.id}`} className="link1" 
                        style={{fontSize:'13px'}}>
                          {event.shortTitle}</a>
                    </td>
                    <td valign="top">{event.date}</td>
                    <td valign="top">{event.location}</td>
                    <td valign="top">{event.pictureCount}</td>
                </tr>
                ))}
                
                </tbody>
            </table>
        </div>
        <div style={{float:"left", marginLeft:'10px', width:'190px'}}>
            <h2>All Events</h2>
            <ul id="navsub">
            {years.map((year, index) => (
                <li key={year}>
                  <a href={`/events/${year}`}>{year} Off-Road Events</a>
                </li>
            ))}
            </ul>
        </div>
        <br style={{clear:"both"}} />
        &nbsp;
    </div>
  );
}

export default Events;